<template>
    <div class="warp">
        <!-- <Viewer /> -->
        <Aside />
        <div class="con">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
const Viewer = ()=>import('./viewer/viewer.vue')
const Aside = ()=>import('./Aside.vue')

export default {
    data(){
        return {
        }
    },
    components:{
        Viewer,Aside
    },
    methods:{
    }
}
</script>

<style lang="less" scoped>
.warp{
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: space-between;
    .con{
        width: 80vw;
        height: 100%;
    }
}
</style>